import { useZipContext } from '@/context/ZipContext';
import { handleFilteredSearch } from '@/lib/searchFilters';
import { FC } from 'react';
import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import { IncentiveMoneySignIcon } from '../../icons';

export const IncentivesCardHomepage: FC = () => {
  const { preferredZip } = useZipContext();

  return (
    <div
      role="button"
      aria-label="Search EVs with incentives"
      onClick={() =>
        handleFilteredSearch({
          input: '',
          zip: preferredZip,
        })
      }
      className="group flex w-full flex-col justify-between gap-s overflow-hidden rounded-small bg-blue-medium p-2xl"
    >
      <div className="flex text-h2SemiBold text-neutral-0">
        Save up to $7,500 or more with incentives
      </div>
      <div className="text-body1Regular text-neutral-0">
        Navigate federal incentives to maximize your savings
      </div>
      <div className="pointer-events-none relative flex h-[175px] justify-end ml:max-h-[200px]">
        <div className="absolute bottom-[-175px] right-[-135px] rotate-[15deg] group-hover:[animation:tiltedSpin_2s_linear_infinite] ml:right-[-25px] ml:top-[-30px]">
          <IncentiveMoneySignIcon />
        </div>
      </div>
      <style jsx global>{`
        @keyframes tiltedSpin {
          0% {
            transform: rotateX(15deg) rotateY(0deg) rotate(15deg);
          }
          100% {
            transform: rotateX(15deg) rotateY(360deg) rotate(15deg);
          }
        }
      `}</style>
      <div className="flex gap-s text-body1Medium text-neutral-0">
        <div className="flex">
          <Button
            variant={ButtonVariants.Primary}
            theme="dark"
            aria-label={'Search EVs'}
          >
            Search EVs
          </Button>
        </div>
      </div>
    </div>
  );
};
